"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const AspectRatioBox = _ref => {
  let {
    tagType,
    prefix,
    className,
    ratio,
    children,
    ...others
  } = _ref;
  const classes = (0, _classnames.default)(`${prefix}aspect-ratio-box`, ratio && `${prefix}aspect-ratio-box--${ratio}`, className);
  const SpanOrDiv = tagType;
  return _react.default.createElement(SpanOrDiv, _extends({
    className: `${classes}`
  }, others), children);
};
AspectRatioBox.defaultProps = {
  prefix: '',
  tagType: 'span',
  ratio: 'standard'
};
var _default = AspectRatioBox;
exports.default = _default;